import { asyncDefaults, makeAsyncReducer, mergeReducers } from '../../../ui-lottery/src/utils/async_utils';
import * as types from '../constants/actions';

const fetchOrganizations = makeAsyncReducer(types.FETCH_ORGANIZATIONS);

export default mergeReducers(asyncDefaults([]), types.PREFIX, fetchOrganizations);

export const getOrganizations = (state) => state.portal.organizations.data;

export const getOrganization = (state, orgId) => {
  if (!state.portal.organizations.loaded || state.portal.organizations.error != null) {
    return null;
  }

  const findOrg = (org) => {
    if (org.id === orgId) {
      return org;
    }

    if (org.children) {
      let result = null;
      for (let idx = 0; result == null && idx < org.children.length; idx++) {
        result = findOrg(org.children[idx]);
      }

      return result;
    }

    return null;
  };

  // Handle Root level data stewards
  if (orgId === '') {
    return ({
      id: '',
      name: 'Root',
      parent_id: '',
      path: [],
      children: state.portal.organizations.data
    });
  }

  let result = null;

  for (let idx = 0; result == null && idx < state.portal.organizations.data.length; idx++) {
    result = findOrg(state.portal.organizations.data[idx]);
  }

  return result;
};
